import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const CATS_API_KEY = "dd6b2d56-82b6-4a74-a140-a8c5ed79c741";

interface Breed {
	id: string;
	name: string;
	image: {
		height: number;
		id: string;
		url: string;
		width: number;
	};
}

export const catsApiSlice = createApi({
	reducerPath: "cats/api",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://api.thecatapi.com/v1",
		prepareHeaders(headers) {
			headers.set("x-api-key", CATS_API_KEY);

			return headers;
		}
	}),
	endpoints(builder) {
		return {
			fetchBreeds: builder.query<Breed[], number | void>({
				query(limit = 5) {
					return `/breeds?limit=${limit}`;
				}
			})
		};
	}
});

export const { useFetchBreedsQuery } = catsApiSlice;
